<h1 class="mt-1 mb-4">Client Information</h1>
<form clientForm #form class="col-12 col-md-11 step1">
  <div footer class="display-flex flex-column">
      <div class="row">
          <div class="col-12 offset-md-5 col-md-7 pb-2 has-error ps-0" [class.has-danger]="confirm.touched && !confirm.valid">
              <div [visible]="confirm.touched && confirm.hasError('mustBeChecked')" [keepFlow]="true"
                   class="form-control-feedback">Please confirm everything on this page is correct.
              </div>
          </div>
          <div class="col-12 offset-md-5 col-md-7 pb-2 ps-0">
              <label class="form-check">
                  <input type="checkbox" [formControl]="confirm" class="form-check-input">
                  <span class="form-check-label">I confirm all information on this page is correct</span>
              </label>
          </div>
      </div>
      <div class="display-flex flex-row w-100 justify-content-end pt-2">
          <button type="submit" (click)="submit()" class="btn btn-primary next-btn">Next</button>
      </div>
  </div>
</form>
